import { useEffect, useState } from "react";
import { Alert } from "react-bootstrap";
import { useMutation, useQuery } from "react-query";
import { useNavigate, useParams } from "react-router-dom";
import NavigasiAdmin from "../../components/NavigasiAdmin";
import { API } from "../../config/api";

function EditProduct() {
  document.title = "Edit Product";

  let navigate = useNavigate();
  const { id } = useParams();
  const [message, setMessage] = useState("");

  const [categories, setCategories] = useState([]); //Store all category data
  const [categoryId, setCategoryId] = useState([]); //Save the selected category id
  const [preview, setPreview] = useState(null); //For image preview
  const [product, setProduct] = useState({}); //Store product data
  const [form, setForm] = useState({
    image: "",
    name: "",
    desc: "",
    price: "",
    qty: "",
  }); //Store product data

  // Fetching detail product data by id from database
  let { data: products, refetch } = useQuery("productCache", async () => {
    const response = await API.get("/product/" + id);
    return response.data.data;
  });

  // Fetching category data
  let { data: categoriesData, refetch: refetchCategories } = useQuery(
    "categoriesCache",
    async () => {
      const response = await API.get("/categories");
      return response.data.data;
    }
  );

  useEffect(() => {
    if (products) {
      setPreview(products.image);
      setForm({
        ...form,
        name: products.name,
        desc: products.desc,
        price: products.price,
        qty: products.qty,
      });
      setProduct(products);
    }
    if (categoriesData) {
      setCategories(categoriesData);
    }
  }, [products, categoriesData]);

  // For handle if category selected
  const handleChangeCategoryId = (e) => {
    const id = e.target.value;
    const checked = e.target.checked;

    if (checked === true) {
      setCategoryId([...categoryId, parseInt(id)]);
    } else {
      let newCategoryId = categoryId.filter((categoryIdItem) => {
        return categoryIdItem !== id;
      });
      setCategoryId(newCategoryId);
    }
  };

  // Handle change data on form
  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]:
        e.target.type === "file" ? e.target.files : e.target.value,
    });

    // Create image url for preview
    if (e.target.type === "file") {
      let url = URL.createObjectURL(e.target.files[0]);
      setPreview(url);
    }
  };

  const handleSubmit = useMutation(async (e) => {
    try {
      e.preventDefault();

      const config = {
        headers: {
          "Content-type": "multipart/form-data",
        },
      };

      const formData = new FormData();
      if (form.image) {
        formData.set("image", form?.image[0], form?.image[0]?.name);
      }
      formData.set("name", form.name);
      formData.set("desc", form.desc);
      formData.set("price", form.price);
      formData.set("qty", form.qty);
      formData.set("categoryId", categoryId);

      const response = await API.patch(
        "/product/" + product.id,
        formData,
        config
      );
      console.log(response.data);

      navigate("/product");
    } catch (error) {
      const alert = (
        <Alert variant="danger" className="py-1">
          {error.response.data.message || error.response.data.error.message}
        </Alert>
      );
      setMessage(alert);
      console.log(error);
    }
  });

  return (
    <>
      <NavigasiAdmin active="product" />
      <div className="edit-product-section container my-3">
        <p className="my-5 fw-bold">Edit Product</p>
        <form onSubmit={(e) => handleSubmit.mutate(e)}>
          {message && message}

          {preview && (
            <div>
              <img
                src={preview}
                style={{
                  maxWidth: "150px",
                  maxHeight: "150px",
                  objectFit: "cover",
                  marginBottom: 50,
                }}
                alt="preview"
              />
            </div>
          )}
          <div className="image-div mb-4">
            <label htmlFor="image" className="label-image w-100">
              <span className="me-4 btn-upload-image">Upload Image</span>
              <span>Choose image</span>
            </label>
            <input
              type="file"
              name="image"
              id="image"
              hidden
              onChange={handleChange}
            />
          </div>
          <input
            type="text"
            placeholder="Product Name"
            className="form-control bg-dark mb-4 text-white"
            name="name"
            onChange={handleChange}
            value={form?.name}
          />
          <textarea
            rows="4"
            className="form-control bg-dark mb-4 text-white"
            placeholder="Product Desc"
            name="desc"
            onChange={handleChange}
            value={form?.desc}
          ></textarea>
          <input
            type="text"
            placeholder="Price (Rp.)"
            name="price"
            onChange={handleChange}
            value={form?.price}
            className="form-control bg-dark mb-4 text-white"
          />
          <input
            type="text"
            placeholder="Stock"
            name="qty"
            onChange={handleChange}
            value={form?.qty}
            className="form-control bg-dark mb-4 text-white"
          />
          <div className="card-form-input mt-4 px-2 py-1 pb-2">
            <div className="text-secondary mb-1" style={{ fontSize: "15px" }}>
              Category
            </div>
            {product &&
              categories?.map((item) => (
                <label key={item?.id} className="checkbox-inline me-4">
                  <input
                    type="checkbox"
                    value={item?.id}
                    onClick={handleChangeCategoryId}
                  />
                  <span className="ms-2">{item?.name}</span>
                </label>
              ))}
          </div>
          <button className="btn btn-success fw-bold w-100">Save</button>
        </form>
      </div>
    </>
  );
}

export default EditProduct;
